// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_thumbnail .content_viewer {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #aeb4c1;
  border-radius: 6px;
  padding: 1rem;
  width: 64.88vw;
  height: 83vh;
  position: fixed;
  top: 7%;
  left: 25%;
}
.popup_thumbnail .content_viewer .popup_close_icon {
  display: flex;
  justify-content: end;
  width: 96%;
  margin: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/component/PoppupThumbnail/popupThumbnail.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;AAAJ;AACI;EACE,aAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;AACN","sourcesContent":[".popup_thumbnail {\n  .content_viewer {\n    box-sizing: border-box;\n    background: #ffffff;\n    border: 1px solid #aeb4c1;\n    border-radius: 6px;\n    padding: 1rem;\n    width: 64.88vw;\n    height: 83vh;\n    position: fixed;\n    top: 7%;\n    left: 25%;\n    .popup_close_icon {\n      display: flex;\n      justify-content: end;\n      width: 96%;\n      margin: 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
